import { render } from "./tender_position.vue?vue&type=template&id=d4a07284&scoped=true"
import script from "./tender_position.vue?vue&type=script&lang=js"
export * from "./tender_position.vue?vue&type=script&lang=js"

import "./tender_position.vue?vue&type=style&index=0&id=d4a07284&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a07284"],['__file',"vue/js/components/contragent/tender/tabs/tender_position.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4a07284"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4a07284', __exports__)) {
    console.log('reload')
    api.reload('d4a07284', __exports__)
  }
  
  module.hot.accept("./tender_position.vue?vue&type=template&id=d4a07284&scoped=true", () => {
    console.log('re-render')
    api.rerender('d4a07284', render)
  })

}


export default __exports__